'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withParams2.default)({ type: 'email' }, function (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  }
  var reg = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;
  return reg.test(value);
});


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/email.js
// module id = 779
// module chunks = 0